export default __webpack_public_path__ + "static/media/sum~bmbhXBDx.90dbc7df.svg";